import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import VideoBox from '../../../components/videoBox';
import NewsList from '../../../components/newsList';
import Promote from '../../../components/promote';

class RightNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { videoTitle, videoBox, videoList, videoListAd, promoteInVideo },
        } = this.props;

        return (
            <div className={styles.right_box}>
                <Chip id="170170" type="struct" title="视频标题" groupName="视频区" content={videoTitle}>
                    <NewsTitle size="short" />
                </Chip>
                <Chip
                    id="255853"
                    type="recommend"
                    title="视频盒"
                    groupName="视频区"
                    content={videoBox}
                    translate="handleVideoBoxData">
                    <VideoBox />
                </Chip>
                <Chip
                    id="255854"
                    type="recommend"
                    title="视频列表"
                    groupName="视频区"
                    content={videoList}
                    translate="handleNewsData">
                    <NewsList isVideoList size="short" ad={videoListAd} />
                </Chip>
                {promoteInVideo && (
                    <Chip id="200151" type="struct" title="铺底推广" groupName="视频区" content={promoteInVideo}>
                        <Promote />
                    </Chip>
                )}
            </div>
        );
    }
}

export default errorBoundary(RightNewsBox);
